import { animate } from "motion";

const generatePath = (el) => {
  const block1 = el.querySelector(".about-block-1");
  const block2 = el.querySelector(".about-block-2");
  const block3 = el.querySelector(".about-block-3");

  if (block1 && block2 && block3) {
    const holder = el.querySelector(".about-blocks");
    const svg = el.querySelector(".about-blocks-svg");

    const holderRect = holder.getBoundingClientRect();
    const block1Rect = block1.getBoundingClientRect();
    const block2Rect = block2.getBoundingClientRect();

    svg.setAttribute("viewBox", `-1 -1 ${holderRect.width} ${holderRect.height}`);

    const pathParts = [`M${holderRect.width} 0`];

    let a = 70;
    let b = 80;

    if (window.matchMedia("(min-width: 1280px)").matches) {
      a = 80;
      b = 100;
    }

    pathParts.push(`H${b}`);
    pathParts.push(`C${a} 0 0 0 0 ${b}`);
    pathParts.push(`V${block1Rect.height - b}`);
    pathParts.push(`C0 ${block1Rect.height - a} 0 ${block1Rect.height} ${b} ${block1Rect.height}`);
    pathParts.push(`H${holderRect.width - b}`);
    pathParts.push(
      `C${holderRect.width - a} ${block1Rect.height} ${holderRect.width} ${block1Rect.height} ${holderRect.width - 2} ${block1Rect.height + b}`,
    );
    pathParts.push(`V${block1Rect.height + block2Rect.height - b}`);
    pathParts.push(
      `C${holderRect.width - 2} ${block1Rect.height + block2Rect.height - a} ${holderRect.width} ${block1Rect.height + block2Rect.height} ${holderRect.width - b} ${block1Rect.height + block2Rect.height}`,
    );
    pathParts.push(`H${b}`);
    pathParts.push(
      `C${a} ${block1Rect.height + block2Rect.height} 0 ${block1Rect.height + block2Rect.height} 0 ${block1Rect.height + block2Rect.height + b}`,
    );
    pathParts.push(`V${holderRect.height}`);

    const pathData = pathParts.join("");

    if (holder.classList.contains("did-animate")) {
      svg.innerHTML = `<path d="${pathData}" stroke="white" stroke-width="2" fill="none" />`;
    } else {
      svg.innerHTML = `<path d="${pathData}" stroke="white" stroke-width="2" fill="none" class="line-path" />`;
    }
  }
};

document.querySelectorAll(".element-about").forEach((el) => {
  window.addEventListener("resize", () => {
    generatePath(el);
  });

  generatePath(el);

  const holder = el.querySelector(".about-blocks");

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        setTimeout(async () => {
          await animate(holder.querySelector(".line-path"), { strokeDashoffset: 0 }, { duration: 3, easing: "linear" })
            .finished;

          holder.classList.add("did-animate");
        }, 250);

        observer.disconnect();
      }
    },
    {
      threshold: 0.1,
    },
  );

  observer.observe(holder);
});
